import React from 'react';
import Icon from './Icon';

const ForestIcon = (props) => (
    <Icon {...props} strokeWidth={1}>
        <path d="M8 12L12 6L16 12" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10 12V18M14 12V18" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M4 14L8 6L12 14M6 14V18M10 14V18" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12 14L16 6L20 14M14 14V18M18 14V18" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M3 18h18" strokeLinecap="round" strokeLinejoin="round" />
    </Icon>
);

export default ForestIcon;